import { getToken } from '~/auth/token';
import { client } from './v2/client.gen';

client.setConfig({
    baseUrl: '/api/v2',
    throwOnError: true,
    responseStyle: 'data',
});

client.interceptors.request.use((request) => {
    const token = getToken();
    if (token) {
        request.headers.set('Authorization', `Bearer ${token}`);
    }
    return request;
});

export { client };
export * from './v2/sdk.gen';
export * from './v2/types.gen';
